import React,{useState,useEffect} from 'react';
import {Row,Col,Button,Form, Spinner, Badge} from 'react-bootstrap';
import { RightSidebarNuevaCotizacion } from '../RightSidebar/RightSidebar';
import { useSelector,useDispatch,getState } from 'react-redux';
import { setInitData,setStateHome, setStateGlobal, } from '../../reducers/appReducer';
import './EditarTramite.css';
import '../Directory/Directory.css';

import { number_format, uniqid, } from "../../utils/utils";
import moment from "moment";
import "moment/locale/es";

moment.locale("mx");

const reminder = moment().add(2, 'days').format('DD/MM/YYYY') + ' 1:00 PM'

function _GET(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
}

export const EditarTramite = ({socket}) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  let [service,setService] = useState([])

  const [sidebar,setSidebar] = useState(false);
  const [dependencias,setDependencias] = useState([]);

  const [arrPreCotizacion,setPreCotizacion] = useState([]);


  const [servicios,setServicios] = useState([]);
  const [requisitos,setRequisitos] = useState([]);
  const [indexCategoria,setIndexCategoria] = useState(-1);
  const [indexDependencia,setIndexDependencia] = useState(-1);
  const [indexServicios,setIndexServicios] = useState(-1);

  const [arrMultiCotizacion, setMultiCotizacion] = useState([]);

  const [idUser,setIdUser] = useState("");
  const [data,setData] = useState({
    indexCategoria: '',
    indexDependencia: '',
    indexServicios: '',
    tabView: 'formulario',
    id_usuario: '',
    id_cotizacion: uniqid(),
    formulario: [],
    dataSearch:'',
    formaPago: 'Efectivo',
    metodoPago: 'contado',
    costo: 0,
    nombreCliente: 'cargando...',
    totalDeuda: 0,
    totalCotizaciones: 0,
    vendedor: '',
  })

  const [arrClientes,   setClientes] = useState([]);
  const [arrEjecutivos, setEjecutivos] = useState([]);
  const [arrVendedores, setVendedores] = useState([]);

  const getDirectorioNuevo = () => {
    const data = {  }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getDirectorioNuevo',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {

      setClientes( res.clientes.documents )
      setEjecutivos( res.ejecutivos.documents )
      setVendedores( res.vendedores.documents )
    })
  }

  useEffect( () => {
    getListTramite();
    // getDirectorioNuevo()
  }, [])

  const getListTramite = () => {
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getListTramite',{
      method : 'POST',
      mode: 'cors',
    })
    .then( respionse => respionse.json())
    .then( response => {
      setService(response.data)
    })
  }

  const updateListTramite = () => {
    const dataServer = {
      data: service
    }

    if(!window.confirm("¿Estás seguro de actualizar esta información?\nEsta acción no se puede deshacer."))
      return false

    // console.log(dataServer)
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateListTramite',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(dataServer)
    })
    .then( response => response.json() )
    .then( response => {
      alert("Datos actualizados correctamente")
      // window.location.reload();
    })
  }

  const selectToPrecotizacion = (item) => {

    let indexNotAdd = -1
    for( var a in arrPreCotizacion ) {

      if(arrPreCotizacion[a].nombre === item.nombre)
        indexNotAdd = a
    }

    if (item.costo_dependencia) {
      if(indexNotAdd === -1)
        arrPreCotizacion.push(item)
      else {
        arrPreCotizacion.splice(indexNotAdd, 1)
      }
    }

    setPreCotizacion(arrPreCotizacion)
  }

  const setToAddMulticotizacion = (item, index) => {
    arrMultiCotizacion.push({
      ...item,
      indexServicios: index
    })
    setMultiCotizacion(arrMultiCotizacion)
  }


  return(
    <div className="container-fluid">
      <div className="ws-main-container-directorio">

        <Row className="mb-3"> 
          <Col xs={12}>
            <Button className="ws-btn-blue-2"
            onClick={ () => {
              window.location.href = "/"
            }}
            ><i className="bi bi-arrow-left"></i>&nbsp;Atrás</Button> 
          </Col>
        </Row>

        <Row>

          <Col xs={3} className={(indexCategoria!==-1) ? 'ws-column-divider' : ''}>
            <h2 className="ws-column-title">Departamento</h2>
            <ul className="ws-column-list">
              {
                service.map((t,e) => (
                <li key={`list-${e}`} className={`ws-list-categoria ${(indexCategoria===e) ? 'active' : ''} `}
                onClick={ () => {
                  setData({...data,indexCategoria:e})
                  setIndexCategoria(e);
                  setIndexDependencia(-1);
                  setIndexServicios(-1);
                  setDependencias(t.dependencias)
                  setServicios([]);
                  setRequisitos([]);
                } }
                >{t.categoria} {(indexCategoria===e) && <i className="bi bi-chevron-right icon-list-right"></i>} </li> 
                ))
              } 
            </ul>
          </Col>

          <Col xs={3} className={(indexDependencia!==-1) ? 'ws-column-divider' : ''}>
            {
                <h2 className="ws-column-title">Selecciona una dependencia</h2>
            }
            <ul className="ws-column-list">
              {
                dependencias.map((t,e) => (
                  <li key={`list-${e}`} className={`ws-list-categoria ${(indexDependencia===e) ? 'active' : ''} `}
                  onClick={ () => {
                    setData({...data,indexDependencia:e})
                    setIndexDependencia(e);
                    setIndexServicios(-1);
                    setServicios(t.servicios);
                    setRequisitos([]);
                  } }
                  >{t.nombre} {(indexDependencia===e) && <i className="bi bi-chevron-right icon-list-right"></i>}</li> 
                ))
              }
            </ul>
          </Col>
          <Col xs={3} className={(indexServicios!==-1) ? 'ws-column-divider' : ''}>
            {
                <h2 className="ws-column-title">Selecciona un servicio</h2>
            }
            <ul className="ws-column-list">
              {
                servicios.map((t,e) => (
                  <>
                    <li key={`list-${e}`} className={`ws-list-categoria ${(indexServicios===e) ? 'active' : ''} `}
                    onClick={ () => {

                      setToAddMulticotizacion(t,e)

                      setIndexServicios(e);
                      setRequisitos(t.requisitos)
                      selectToPrecotizacion(t)

                      let newData = t.requisitos
                      setData({...data, formulario: newData, indexServicios: e, costo: t.costo_honorario ? (t.costo_honorario + t.costo_dependencia) : 0})
                    } }
                    >
                    {t.nombre}
                    {t.costo_honorario && <Badge bg='danger' pill className={'ws-list-categoria-badge'}>{t.costo_honorario ? `Tiene costo` : null}</Badge>}
                    {(indexServicios===e) && <i className="bi bi-chevron-right icon-list-right"></i>}</li>
                  </>
                  
                ))
              }
            </ul>
          </Col>
          <Col xs={3}>

            <Row>

              <Col>
                <h2
                  style={{cursor: 'pointer'}}
                  onClick={() => { setData({...data, tabView: 'costos', }) }}
                  className="ws-column-title">Actualizar costos</h2>
              </Col>
              <Col>
                <h2
                  style={{cursor: 'pointer'}}
                  onClick={() => { setData({...data, tabView: 'formulario', }) }}
                  className="ws-column-title">Actualizar formulario</h2>
              </Col>

            </Row>

            {
              data.tabView === 'costos' &&
              <Form>  
                <Form.Group className="mb-3">  
                  <Form.Label>Costo dependencia</Form.Label>
                  <Form.Control name="costo_dependencia" id="costo_dependencia" value={
                    (servicios[indexServicios]?.costo_dependencia) ?
                      servicios[indexServicios]?.costo_dependencia
                    : ''
                  } 
                  onChange={
                    (e) => {
                      let valueInput = parseFloat(e.target.value);
                      let newServiceArray = [...service];
                      if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                        newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].costo_dependencia = valueInput;
                      }
                      setService(newServiceArray)
                    }
                  }
                  disabled={
                    (indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) ? false : true
                  }
                  />
                </Form.Group>
                <Form.Group className="mb-3">  
                  <Form.Label>Costo honorario</Form.Label>
                  <Form.Control name="costo_honorario" id="costo_honorario" value={
                    (servicios[indexServicios]?.costo_honorario) ?
                      servicios[indexServicios]?.costo_honorario
                    : ''
                  } 
                  onChange={
                    (e) => {
                      let valueInput = parseFloat(e.target.value);
                      let newServiceArray = [...service];
                      if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                        newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].costo_honorario = valueInput;
                      }
                      setService(newServiceArray)
                    }
                  }
                  disabled={
                    (indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) ? false : true
                  }
                  />
                </Form.Group>
                <Form.Group>  
                  <Button onClick={
                    () => {
                      updateListTramite()
                    } 
                  }>Actualizar</Button>
                </Form.Group>
              </Form>
            }

            {
              data.tabView === 'formulario' &&
              <Form>
                {
                  servicios[indexServicios]?.requisitos &&
                    servicios[indexServicios]?.requisitos.map((t,e) => (
                      <div style={{backgroundColor: '#ededed'}} className="p-2 mb-3">
                        <input className="form-control" type={'text'} value={t.nombre} onChange={(ev) => {

                          let valueInput = ev.target.value;
                          let newServiceArray = [...service];
                          if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                            newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].requisitos[e].nombre = valueInput;
                          }
                          setService(newServiceArray)
                        }} />
                        <p>Actual: {t.tipo === 'text' ? 'Texto' : 'Archivo'}</p>

                        <select className="form-select mb-3" onChange={(ev) => {

                          let valueInput = ev.target.value;
                          let newServiceArray = [...service];
                          if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                            newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].requisitos[e].tipo = valueInput;
                          }
                          setService(newServiceArray)

                        }} >
                          <option>Pulsa para cambiar</option>
                          <option value={'text'}>Texto</option>
                          <option value={'file'}>Archivo</option>
                        </select>

                        <p 
                        className="btn btn-primary ws-btn-blue-2"
                        onClick={() => {

                          let newServiceArray = [...service];
                          if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                            newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].requisitos.splice(e, 1);
                          }
                          setService(newServiceArray)
                        }}><i class="bi bi-x-lg"></i> Eliminar registro</p>
                      </div>

                    ))
                }
                <hr />
                <Form.Group>  
                  <Button 
                  className="ws-btn-blue-2 mb-3"
                  onClick={
                    () => {
                      let newServiceArray = [...service];
                      const requisitos = newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].requisitos
                      requisitos.push({
                        nombre: `Requisito #${ requisitos.length + 1 }`,
                        tipo: "text",
                      })

                      if(indexCategoria !== -1 && indexDependencia !== -1 && indexServicios !== -1) {
                        newServiceArray[indexCategoria].dependencias[indexDependencia].servicios[indexServicios].requisitos = requisitos
                      }
                      setService(newServiceArray)
                    } 
                  }><i class="bi bi-plus-lg"></i> Agregar nuevo campo</Button>

                </Form.Group>
                <Form.Group>  
                  <Button 
                  className="ws-btn-blue-2"
                  onClick={
                    () => {
                      updateListTramite()
                    } 
                  }><i class="bi bi-check-lg"></i> Actualizar</Button>
                </Form.Group>
              </Form>
            }

            
          </Col>

        </Row>
      </div>
    </div> 
  )
}
